module.exports = __webpack_public_path__ + "img/eco-negative-with-symptons.faed37ce.png";